// This file is AUTOGENERATED, do not edit it manually!!!

export const menu = {
    activityList: 'Centre d\'activité',
    addlicenses: 'Ajouter des licences',
    approvals: 'Demandes d\'approbation',
    billingReport: 'Rapport de facturation',
    commonReports: 'Rapports communs',
    companySettings: 'Paramètres de l\'entreprise',
    customers: 'Clients',
    customfields: 'Champs personnalisés',
    dashboard: 'Tableau de Bord',
    forms: 'Formulaires personnalisés',
    generalOptions: 'Paramètres du compte',
    guestPortal: 'Portail des invités',
    logout: 'Se déconnecter',
    myassignments: 'Mes affectations',
    myoptions: 'Mes paramètres',
    mySettingsNotifications: 'Notifications',
    mySettingsOptions: 'Paramètres avancés',
    mySettingsProfile: 'Profil',
    myvacations: 'Mes congés',
    notificationCenter: 'Notifications',
    notifications: 'Paramètres de notification',
    payrollReport: 'Rapport de paie',
    portfolios: 'Portefeuilles',
    powerbi: 'Informatique décisionnelle',
    presetsHideViewTooltip: 'Masquer la vue',
    presetsListTitle: 'Vues enregistrées',
    ratecards: 'Cartes tarifaires',
    reportgenerator: 'Rapport personnalisé',
    reports: 'Rapports',
    resourcesPage: 'Ressources',
    roles: 'Rôles',
    search: 'Chercher',
    summaryReport: 'Rapport récapitulatif des saisies de temps',
    support_center: 'Centre d\'assistance',
    support_chat: 'Chat d\'assistance',
    systemLists: 'Listes système',
    timelogs: 'Saisies de temps',
    updateLicense: 'Mettre à jour la licence',
    users: 'Utilisateurs',
    vacationsreport: 'Congés',
    whatif: 'Simulation de chargement des ressources',
    workflows: 'Flux de travaux',
};
